import type { JSX } from 'react'
import type { ISecondaryOpacityFontButton1WithAngleProps } from 'atoms/ActionButton/Templates'
import type { IDropdownHeaderProps } from '../DropdownHeader'

import { SecondaryOpacityFontButton1WithAngle } from 'atoms/ActionButton/Templates'
import { IconNames } from 'atoms/Icon'
import { DropdownHeader } from '../DropdownHeader'

export interface IDropdownHeaderSeasonsProps extends Omit<
  IDropdownHeaderProps,
  'children'
> {
  title?: ISecondaryOpacityFontButton1WithAngleProps['title']
  icon?: ISecondaryOpacityFontButton1WithAngleProps['icon']
}

export const DropdownHeaderSeasons = ({
  title = '',
  icon = IconNames.angleDown,
  ...rest
}: IDropdownHeaderSeasonsProps): JSX.Element => (
  <DropdownHeader {...rest}>
    <SecondaryOpacityFontButton1WithAngle
      onClick={rest.onClick}
      title={title}
      icon={icon}
    />
  </DropdownHeader>
)
